import { effect, inject, Injectable, signal } from '@angular/core';
import { LeverandoerOpkraevningSearchParams } from './leverandoer-opkraevning-search/leverandoer-opkraevning-search-params.model';
import { LeverandoerOpkraevningDatasource } from './leverandoer-opkraevning.datasource';
import { LeverandoerOpkraevning } from './leverandoer-opkraevning.model';
import { SimpleApi } from '@core/api/simple.api';
import { downloadFromBlob } from '@core/api/api-utils';

@Injectable({
  providedIn: 'root',
})
export class LeverandoerOpkraevningService {
  datasource = inject(LeverandoerOpkraevningDatasource);
  simpleApi = inject(SimpleApi);

  constructor() {
    effect(() => {
      if (this.datasource.isLoaded()) {
        const data = this.datasource.data();
        if (data && data.totalRowCount > 0) {
          this.activeTab.set('result');
        }
      }
    });
  }

  selectedLeverandoerOpkraevning = signal<LeverandoerOpkraevning | undefined>(
    undefined
  );
  activeTab = signal('search');
  mode = signal('update');

  searchLeverandoerOpkraevning(
    searchParams: LeverandoerOpkraevningSearchParams
  ) {
    this.selectedLeverandoerOpkraevning.set(undefined);
    this.datasource.searchParams.set(searchParams);
    this.datasource.loadData();
  }

  async selectLeverandoerOpkraevningResultRow(
    leverandoerOpkraevning: LeverandoerOpkraevning
  ) {
    this.mode.set('update');
    await this.selectLeverandoerOpkraevning(leverandoerOpkraevning);

    if (leverandoerOpkraevning) {
      this.activeTab.set('detail');
    }
  }

  async selectLeverandoerOpkraevning(
    leverandoerOpkraevning: LeverandoerOpkraevning
  ) {
    const r = await this.datasource.getById(leverandoerOpkraevning.id!);
    this.selectedLeverandoerOpkraevning.set(r);
  }

  async exportData(leverandoerOpkraevningId: number) {
    const blob = await this.simpleApi.getBlob(
      `/api/admin/risikoopkraevninger/excel`,
      {
        leverandoerOpkraevningId: leverandoerOpkraevningId,
      }
    );
    downloadFromBlob(blob, 'Leverandøropkræving.xlsx');
  }

  async hentFaktura(leverandoerOpkraevningId: number) {
    const blob = await this.simpleApi.getBlob(
      `/api/admin/leverandoeropkraevninger/faktura`,
      {
        leverandoerOpkraevningId: leverandoerOpkraevningId,
      }
    );
    downloadFromBlob(
      blob,
      'LeverandoerOpkraevning_' + leverandoerOpkraevningId + '.pdf'
    );
  }
}
